<template>
  <div class="col-12">
    <Search
      :title="$lang.payment_list_title"
      :allowFields="$lang.payment_allow_fields"
      :hiddenFields="hiddenFields"
      :url="url"
      :showAlert="true"
      :titleAlert="titleAlert"
      colorAlert="info"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :filterCatch="true"
      :showTotals="true"
      :openNewTab="true"
      removeModalSize="lg"
      :dynamicButtons="dynamicButtons"
      :remove_item="removeItem"
      :visibleAdd="isAdmin(permissions, ['admin'])"
      :otherExportExcelParams="{ parvandeh_code: parvandehCode }"
      ref="search"
      @getPermisson="updatePermissions"
      @getOther="updateOtherData"
    >
      <template slot="addModal" slot-scope="search">
        <AddPayment
          :permissions="permissions"
          @close="search.close"
          @getData="getData"
        />
      </template>
    </Search>
    <b-modal v-model="editModal" hide-footer hide-header>
      <EditPayment
        :permissions="permissions"
        :id="editId"
        @close="closeEditModal"
        @getData="getData"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddPayment from "./addPayment.vue";
import EditPayment from "./editPayment.vue";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl, goToRoute } from "@/shared/utils";
import { computed } from "vue";

export default {
  components: {
    Search,
    AddPayment,
    EditPayment,
  },
  provide() {
    /* guidance: provide this data to all deep child components */
    return {
      PERMISSIONS: computed(() => this.permissions),
      PARVANDEH_CODE: computed(() => this.parvandehCode),
    };
  },
  props: {
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      dynamicButtons: [
        {
          name: "edit",
          click: this.showEditModal,
        },
        {
          name: "view",
          click: this.showEditModal,
        },
        {
          name: "delete",
        },
      ],
      permissions: [],
      hiddenFields: ["created_by", "created_at.jalali"],
      editModal: false,
      editId: null,
      otherData: null,
    };
  },
  computed: {
    url() {
      return generateApiUrl(
        ["cooperation", "parvandeh_payment_cooperation"],
        [this.parvandehCode]
      );
    },
    titleAlert() {
      const fullName = pathOr("", ["parvandeh", "full_name"], this.otherData);
      const parvandehNumber = pathOr(
        "",
        ["parvandeh", "parvandeh_number"],
        this.otherData
      );
      return `لیست اسناد پرداخت مربوط به  <strong class='text-primary'>${fullName}</strong> با شماره پرونده <strong class='text-primary'>${parvandehNumber}</strong>`;
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    goToRoute,
    getData() {
      this.$refs.search.getItems();
    },
    updatePermissions(permissions) {
      this.permissions = permissions;
    },
    updateOtherData(data) {
      this.otherData = data;
    },
    showEditModal(item) {
      this.editId = pathOr(null, ["id"], item);
      this.editModal = true;
    },
    closeEditModal() {
      this.editId = null;
      this.editModal = false;
    },
    async removeItem(item) {
      try {
        const id = pathOr(null, ["id"], item);
        const url = generateApiUrl(
          ["cooperation", "payment_cooperation_id"],
          [id]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.$emit("getData");
        this.close();
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>
